import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';

import {ShareableEmailTemplatesFeatureGate} from '../../../ui/limits/feature-gates/shareable-email-templates-feature-gate';

export function ShareableEmailTemplatesUpsell() {
    const [isFeatureGateOpen, setIsFeatureGateOpen] = React.useState(false);

    return (
        <>
            <button
                type='button'
                className='flex flex-grow justify-end align-center gap-4 pointer-cursor'
                onClick={() => {
                    setIsFeatureGateOpen(true);
                }}
            >
                <Checkbox
                    isLarge={true}
                    checked={false}
                    disabled={true}
                    label='Shared with everyone'
                />
                <UpgradeArrowIcon size={16} color={colors.blue} wrapWithDiv={false} />
            </button>
            <ShareableEmailTemplatesFeatureGate
                isOpen={isFeatureGateOpen}
                onClose={() => {
                    setIsFeatureGateOpen(false);
                }}
            />
        </>
    );
}
